import Layout from '@/apps/layout/components'
import TournamentsDetail from '@/apps/TournamentsDetail'
import React from 'react'

const TournamentsDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <TournamentsDetail />
    </Layout>
  )
}

export default TournamentsDetailPage
